import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  LinearProgress,
  Tooltip,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { Link } from 'react-router-dom';
import StatusBadge from '../components/ReasuableFuncations/StatusBadge';
import apiService from '../components/ReasuableFuncations/api';
import { Info } from '@mui/icons-material';

const MEModule = () => {
  const [indicators, setIndicators] = useState([]);
  const [newIndicator, setNewIndicator] = useState({
    outcome: '',
    output: '',
    pki: '',
    baseline: '',
    target: '',
    current: '',
    category: ''
  });
  const [alignmentStatus, setAlignmentStatus] = useState('Pending');
  const [trendData, setTrendData] = useState([]);
  const [rec, setRec] = useState('COMESA');
  const [selectedCategory, setSelectedCategory] = useState('');

  const indicatorCategories = [
    'Infrastructure Indicators',
    'Policy and Regulatory Indicators',
    'Financial Stability Indicators',
    'Broadband and Connectivity Indicators',
    'Environmental and Climate Action Data',
  ];

  const recOptions = ['COMESA', 'IGAD', 'SADC', 'EAC', 'IOC'];

  useEffect(() => {
    fetchIndicators();
    fetchAlignmentStatus();
    fetchTrendData();
  }, []);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const fetchIndicators = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
          if (!userData) {
        console.error('User data not found. Redirecting to login.');
        return;
      }
      const { selectedOption, regionalNetworkOption, memberStateOption, countryOption } = userData;

      let url = `/indicators`;


      if (selectedOption === 'Comesa') {
        
      } else if (selectedOption === 'Regional Network' && regionalNetworkOption) {
        url += `?regionalNetwork=${regionalNetworkOption}`;
      } else if (selectedOption === 'Member State' && memberStateOption) {
        url += `?country=${countryOption}`;
      }

      const response = await apiService.get(url);
      setIndicators(response.data);
    } catch (error) {
      console.error('Error fetching indicators:', error);
    }
  }; 

  const fetchAlignmentStatus = async () => {
    try {
      const response = await apiService.get(`/alignment`);
      setAlignmentStatus(response.data.status);
    } catch (error) {
      console.error('Error fetching alignment status:', error);
    }
  };

  const fetchTrendData = async () => {
    try {
      const response = await apiService.get(`/trends`);
      setTrendData(response.data);
    } catch (error) {
      console.error('Error fetching trend data:', error);
    }
  };

  const handleChange = (e) => {
    setNewIndicator({ ...newIndicator, [e.target.name]: e.target.value });
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setNewIndicator({ ...newIndicator, category: event.target.value });
  };

  const handleRecChange = (event) => {
    setRec(event.target.value);
  };

  const addIndicator = async () => {
    if (newIndicator.outcome && newIndicator.output && newIndicator.pki) {
      try {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (!userData) {
        console.error('User data not found. Redirecting to login.');
        return;
       }
        const { selectedOption, regionalNetworkOption, memberStateOption, countryOption } = userData;

        const indicatorData = {
          ...newIndicator,
          selectedOption,
          regionalNetworkOption,
          memberStateOption,
          countryOption
        };

        const response = await apiService.post(`/indicators`, indicatorData);
        setIndicators([...indicators, response.data]);
        setNewIndicator({ outcome: '', output: '', pki: '', baseline: '', target: '', current: '', category: '' });
      } catch (error) {
        console.error('Error adding indicator:', error);
        alert('Error adding indicator. Please try again.');
      }
    } else {
      alert('Please fill in all required fields.');
    }
  };

  return (
    <Container maxWidth="md" sx={{ paddingRight: '40px' }}>
      <Paper elevation={20} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" gutterBottom>M&E Module</Typography>
        <Grid container spacing={3}>
          
          
          <Grid item xs={12}>
            <Typography variant="h6">Indicator Tracking</Typography>
            <Grid container spacing={2}>
            
              <Grid item xs={12} md={6}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Category</InputLabel>
                  <Select value={selectedCategory} onChange={handleCategoryChange} label='Category'>
                    {indicatorCategories.map((category) => (
                      <MenuItem key={category} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

             
              <Grid item xs={12} md={6}>
                <TextField
                  label="Outcome"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="outcome"
                  type='number'
                  value={newIndicator.outcome}
                  onChange={handleChange}
                  InputProps={{
         
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Enter the outcome value Achieved">
                          <IconButton edge="end">
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              
              <Grid item xs={12} md={6}>
                <TextField
                  label="Output"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="output"
                  type='number'
                  value={newIndicator.output}
                  onChange={handleChange}
                  InputProps={{
         
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Enter the output value Achieved">
                          <IconButton edge="end">
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              
              <Grid item xs={12} md={6}>
                <TextField
                  label="PKI"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="pki"
                  type='number'
                  value={newIndicator.pki}
                  onChange={handleChange}
                  InputProps={{
         
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Enter the pki value Achieved">
                          <IconButton edge="end">
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

            
              <Grid item xs={12} md={6}>
                <TextField
                  label="Baseline"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="baseline"
                  type='number'
                  value={newIndicator.baseline}
                  onChange={handleChange}
                  InputProps={{
         
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Enter the baseline value Achieved">
                          <IconButton edge="end">
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

             
              <Grid item xs={12} md={6}>
                <TextField
                  label="Target"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="target"
                  type='number'
                  value={newIndicator.target}
                  onChange={handleChange}
                  InputProps={{
         
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Enter the target value Achieved">
                          <IconButton edge="end">
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              
              <Grid item xs={12} md={6}>
                <TextField
                  label="Current Value"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="current"
                  type='number'
                  value={newIndicator.current}
                  onChange={handleChange}
                  InputProps={{
         
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Enter the current value Achieved">
                          <IconButton edge="end">
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Button variant="contained" color="primary" onClick={addIndicator} sx={{ mt: 2 }}>
              Add Indicator
            </Button>
          </Grid>

          
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>Tracked Indicators</Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Category</TableCell>
                    <TableCell>Outcome</TableCell>
                    <TableCell>Output</TableCell>
                    <TableCell>PKI</TableCell>
                    <TableCell>Baseline</TableCell>
                    <TableCell>Target</TableCell>
                    <TableCell>Current</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {indicators.map((indicator, index) => (
                    <TableRow key={index}>
                      <TableCell>{indicator.category}</TableCell>
                      <TableCell>{indicator.outcome}</TableCell>
                      <TableCell>{indicator.output}</TableCell>
                      <TableCell>{indicator.pki}</TableCell>
                      <TableCell>{indicator.baseline}</TableCell>
                      <TableCell>{indicator.target}</TableCell>
                      <TableCell>{indicator.current}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

{/*          
          <Grid item xs={12}>
            <Typography variant="h6">M&E Framework Alignment</Typography>
            <FormControl fullWidth margin="normal">
              <InputLabel>Regional Economic Community</InputLabel>
              <Select value={rec} onChange={handleRecChange} label="Regional Economic Community">
                {recOptions.map((region) => (
                  <MenuItem key={region} value={region}>
                    {region}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography>Alignment Status:<StatusBadge status={alignmentStatus} /></Typography>
            <LinearProgress variant="determinate" value={alignmentStatus === 'Pending' ? 60 : 100} />
          </Grid> */}

         
          {/* <Grid item xs={12}>
            <Typography variant="h6">KPI Trend Analysis</Typography>
            <Typography>Status: <StatusBadge status={trendData.status} /></Typography>
          </Grid> */}

          
          <Grid item xs={12}>
            <Typography variant="h6">Risk Management</Typography>
            <Button variant="contained" color="primary" component={Link} to="/risk-management">Add Risk</Button>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6">Report Generation</Typography>
            <Button variant="contained" color="primary" component={Link} to="/reporting">Generate Report</Button>
          </Grid>

        </Grid>
      </Paper>
    </Container>
  );
};

export default MEModule;
